import { environment } from './environment';
export function EnvironmentBanner() {
  return (
    <div className={`environment ${environment.production ? 'production' : 'nonproduction'}`}>
      <strong>{environment.label}</strong>
      <span>API · {environment.host}/admin/v1</span>
    </div>
  );
}
